import EnterCodeOtp from './EnterCodeOtp.jsx';

export default EnterCodeOtp;